var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _mask, _g, _mask2, _g2, _path44, _path45, _path46, _mask3, _g3, _mask4, _g4, _path47, _path48, _mask5, _g5, _mask6, _g6, _mask7, _g7, _mask8, _g8, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExploreIllo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 439,
    height: 329,
    viewBox: "0 0 439 329",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M180.585 33.5002C180.508 32.5135 181.242 31.6527 182.227 31.5734C186.157 31.2632 188.386 33.008 190.176 34.4123C191.809 35.6906 193.099 36.7029 195.644 36.5023C198.187 36.3017 199.304 35.1004 200.718 33.5795C202.266 31.914 204.194 29.8379 208.125 29.5276C212.055 29.2174 214.284 30.9622 216.074 32.3665C217.706 33.6448 218.996 34.6572 221.542 34.4566C224.084 34.256 225.202 33.0546 226.613 31.5361C228.162 29.8682 230.09 27.7945 234.02 27.4842C237.951 27.174 240.179 28.9188 241.97 30.3231C243.602 31.6014 244.892 32.6138 247.437 32.4132C248.422 32.3362 249.281 33.071 249.36 34.0577C249.44 35.0444 248.704 35.9052 247.719 35.9845C243.788 36.2947 241.56 34.5499 239.769 33.1456C238.137 31.8673 236.847 30.8549 234.302 31.0555C231.759 31.2562 230.644 32.4575 229.23 33.976C227.682 35.6439 225.754 37.7176 221.823 38.0279C217.893 38.3381 215.664 36.5933 213.874 35.189C212.241 33.9107 210.951 32.8984 208.406 33.099C205.864 33.2996 204.746 34.5009 203.333 36.0218C201.784 37.6873 199.856 39.7634 195.926 40.0736C191.995 40.3839 189.767 38.639 187.976 37.2348C186.344 35.9565 185.051 34.9441 182.509 35.1447C181.524 35.2217 180.662 34.4846 180.585 33.5002Z",
    fill: "#FBC49D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M325.689 274.248C325.379 273.308 325.889 272.296 326.828 271.988C330.572 270.752 333.152 271.918 335.224 272.853C337.115 273.707 338.608 274.383 341.029 273.583C343.453 272.783 344.252 271.351 345.265 269.539C346.376 267.551 347.756 265.078 351.501 263.842C355.245 262.606 357.823 263.772 359.895 264.71C361.783 265.564 363.276 266.24 365.7 265.44C368.124 264.64 368.923 263.208 369.935 261.395C371.046 259.408 372.427 256.935 376.171 255.699C379.915 254.462 382.493 255.629 384.566 256.567C386.454 257.42 387.947 258.097 390.37 257.297C391.309 256.986 392.319 257.497 392.627 258.437C392.937 259.377 392.427 260.39 391.488 260.698C387.744 261.934 385.166 260.768 383.094 259.83C381.205 258.976 379.713 258.3 377.289 259.1C374.865 259.9 374.066 261.332 373.053 263.145C371.943 265.132 370.562 267.605 366.818 268.841C363.073 270.077 360.496 268.911 358.423 267.973C356.533 267.12 355.04 266.443 352.618 267.243C350.194 268.043 349.396 269.476 348.383 271.288C347.272 273.275 345.891 275.748 342.147 276.984C338.403 278.221 335.823 277.054 333.75 276.119C331.86 275.265 330.367 274.589 327.945 275.389C327.009 275.699 325.999 275.188 325.689 274.248Z",
    fill: "#FFB0EB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M364.068 88.6491C361.753 84.0934 356.416 80.6807 350.709 78.4857C344.103 75.9454 336.659 75.4649 329.815 73.4331C325.656 72.1991 310.81 64.2331 307.792 63.1764C304.036 61.8631 299.94 61.3895 295.803 61.5808C288.053 61.94 280.884 64.2424 273.775 66.3628C268.17 68.0353 262.086 69.8688 255.952 69.8758C251.801 69.8804 247.653 69.6822 243.502 69.8828C239.911 70.0577 234.507 70.3353 232.488 72.9782C230.273 75.8801 233.68 78.7843 237.154 79.8666C241.385 81.1846 246.296 81.2709 250.823 81.2522C254.541 81.2359 258.248 80.9676 261.965 80.9443C278.006 80.8487 294.31 79.4117 310.274 81.0983C317.118 81.8214 324.236 83.179 330.337 85.2761C332.735 86.1018 335.18 87.0489 337.176 88.3529C339.043 89.5752 340.205 90.8348 340.026 92.526C340.016 92.6217 340.047 92.5353 339.963 92.7873C339.942 92.8526 339.805 93.1558 339.821 93.1582C339.749 93.2655 339.669 93.3681 339.588 93.4708C339.583 93.4754 339.567 93.4941 339.548 93.5151C339.483 93.5687 339.362 93.676 339.339 93.6947C339.236 93.767 339.134 93.837 339.029 93.907C339.013 93.907 338.738 94.0492 338.647 94.0912C338.475 94.1682 338.298 94.2382 338.119 94.3058C338.028 94.3408 337.935 94.3712 337.844 94.4038C337.816 94.4132 337.793 94.4225 337.769 94.4318C337.758 94.4341 337.746 94.4388 337.73 94.4435C335.848 94.994 333.857 95.3042 332.034 95.9737C327.631 97.5926 326.539 101.969 330.698 104.196C334.004 105.967 338.871 106.137 342.806 106.146C348.704 106.158 354.998 105.419 359.413 102.274C364.242 98.8359 366.464 93.3634 364.068 88.6491Z",
    fill: "url(#paint0_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6439 95.962C76.9755 101.197 63.1441 107.506 53.4528 118.493C51.5574 120.644 49.7668 123.147 49.6364 126.014C49.3313 132.718 57.6022 136.198 64.2921 136.567C68.0573 136.774 72.9751 135.652 73.3756 131.897C73.7225 128.661 70.2461 126.27 69.5615 123.091C68.7442 119.296 72.0344 115.937 75.1802 113.669C98.6097 96.7691 129.367 94.8283 158.238 94.987C164.132 95.0196 171.783 93.7576 172.822 87.9446C173.509 84.112 170.417 80.4241 166.784 79.0385C163.152 77.6529 159.123 77.9865 155.246 78.264C145.019 78.9965 134.541 79.1715 124.745 76.1483C116.297 73.5404 109.354 70.8018 105.178 79.5797C100.98 88.3925 101.25 91.9008 90.6439 95.962Z",
    fill: "url(#paint1_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M77.6463 171.543C97.4783 165.83 118.689 164.972 138.917 169.07C140.665 169.425 142.484 169.814 144.209 169.357C145.932 168.9 147.499 167.286 147.239 165.52C146.887 163.136 143.9 162.35 141.506 162.1C134.751 161.396 127.996 160.689 121.241 159.984C119.604 159.814 117.892 159.616 116.526 158.699C115.156 157.782 114.281 155.9 115.038 154.433C116.533 151.531 122.412 152.765 122.929 149.541C123.325 147.075 119.907 146.028 117.413 146.044C105.004 146.135 92.607 147.642 80.536 150.525C78.8408 150.931 77.0548 151.419 75.8696 152.699C74.6844 153.978 74.4748 156.313 75.8976 157.321C77.2248 158.263 79.2297 157.642 80.543 158.606C81.8772 159.586 81.7235 161.76 80.678 163.045C79.6325 164.33 78.0049 164.955 76.4657 165.564C66.6091 169.462 57.3207 174.799 48.9846 181.354C44.7094 184.718 40.5996 188.501 38.0545 193.316C34.8179 199.432 34.1007 213.235 43.8269 213.892C50.2955 214.329 49.5294 209.171 49.2663 204.349C48.2278 185.492 60.3407 176.528 77.6463 171.543Z",
    fill: "url(#paint2_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M418.381 133.138C418.034 133.138 417.691 133.045 417.386 132.865L390.557 116.931C389.898 116.539 389.53 115.799 389.614 115.036C389.698 114.274 390.219 113.632 390.948 113.394L429.625 100.782C430.349 100.546 431.143 100.754 431.66 101.313C432.177 101.873 432.321 102.683 432.028 103.387L420.18 131.934C419.964 132.457 419.531 132.858 418.995 133.038C418.793 133.105 418.585 133.138 418.381 133.138ZM396.25 115.774L417.442 128.361L426.8 105.811L396.25 115.774Z",
    fill: "#75C4FD"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M343.84 84.9122C343.532 84.9122 343.22 84.8912 342.908 84.8516C339.001 84.3407 336.237 80.7391 336.747 76.8249C336.994 74.9284 337.965 73.2419 339.478 72.0779C340.992 70.9115 342.869 70.4077 344.762 70.655C346.655 70.9022 348.338 71.8749 349.503 73.3912C350.667 74.9074 351.17 76.7875 350.923 78.684C350.453 82.281 347.372 84.9122 343.84 84.9122ZM343.826 72.7894C342.741 72.7894 341.69 73.1439 340.817 73.8181C339.767 74.6252 339.097 75.7962 338.924 77.1095C338.57 79.8224 340.487 82.3183 343.195 82.6752C345.905 83.0298 348.397 81.11 348.751 78.3971C348.923 77.0815 348.571 75.7798 347.766 74.7278C346.96 73.6758 345.791 73.004 344.48 72.8313C344.259 72.8033 344.042 72.7894 343.826 72.7894Z",
    fill: "#86E29B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M147.273 141.995C147.162 141.995 147.048 141.993 146.933 141.988C144.812 141.899 142.854 140.99 141.417 139.424C138.451 136.194 138.66 131.148 141.885 128.176C145.11 125.205 150.147 125.414 153.113 128.645C154.55 130.21 155.293 132.242 155.204 134.365C155.116 136.488 154.208 138.452 152.645 139.891C151.167 141.256 149.271 141.995 147.273 141.995ZM147.264 128.295C145.876 128.295 144.486 128.795 143.387 129.809C141.061 131.953 140.91 135.592 143.049 137.92C144.086 139.049 145.499 139.704 147.029 139.77C148.559 139.833 150.021 139.296 151.148 138.258C152.275 137.22 152.929 135.804 152.995 134.272C153.057 132.739 152.522 131.274 151.486 130.145C150.354 128.918 148.81 128.295 147.264 128.295Z",
    fill: "#FFB0EB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M278.127 7.89666C279.619 7.89666 280.828 6.68519 280.828 5.19076C280.828 3.69633 279.619 2.48486 278.127 2.48486C276.635 2.48486 275.426 3.69633 275.426 5.19076C275.426 6.68519 276.635 7.89666 278.127 7.89666Z",
    fill: "url(#paint3_linear)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M307.739 100.543C309.23 100.543 310.44 99.3319 310.44 97.8375C310.44 96.3431 309.23 95.1316 307.739 95.1316C306.247 95.1316 305.037 96.3431 305.037 97.8375C305.037 99.3319 306.247 100.543 307.739 100.543Z",
    fill: "url(#paint4_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1784 179.129C34.6701 179.129 35.8795 177.917 35.8795 176.423C35.8795 174.929 34.6701 173.717 33.1784 173.717C31.6866 173.717 30.4773 174.929 30.4773 176.423C30.4773 177.917 31.6866 179.129 33.1784 179.129Z",
    fill: "url(#paint5_linear)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M316.168 125.244C317.66 125.244 318.869 124.033 318.869 122.538C318.869 121.044 317.66 119.832 316.168 119.832C314.676 119.832 313.467 121.044 313.467 122.538C313.467 124.033 314.676 125.244 316.168 125.244Z",
    fill: "url(#paint6_linear)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M434.612 202.668C437.035 202.668 438.999 200.7 438.999 198.273C438.999 195.846 437.035 193.878 434.612 193.878C432.19 193.878 430.225 195.846 430.225 198.273C430.225 200.7 432.19 202.668 434.612 202.668Z",
    fill: "url(#paint7_linear)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M281.715 71.4339C281.41 71.4339 281.103 71.3896 280.802 71.3009L244.824 60.6756C243.565 60.3024 242.654 59.2037 242.524 57.8927C242.393 56.5818 243.066 55.3245 244.228 54.7086L269.604 41.2631C270.396 40.8433 271.328 40.7709 272.175 41.0672C273.023 41.3611 273.71 41.9956 274.071 42.819L284.67 66.8898C285.178 68.0422 284.97 69.3858 284.141 70.3329C283.52 71.042 282.63 71.4339 281.715 71.4339ZM254.266 56.7124L275.947 63.1156L269.56 48.611L254.266 56.7124Z",
    fill: "url(#paint8_linear)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9932 270.954C53.5973 270.954 53.2062 270.84 52.8639 270.619C52.291 270.245 51.9371 269.613 51.9208 268.927L51.3829 246.191C51.3643 245.416 51.7788 244.698 52.454 244.325C53.1316 243.951 53.9583 243.986 54.6009 244.416L75.7485 258.549C76.3842 258.974 76.7335 259.713 76.6613 260.476C76.5891 261.239 76.1025 261.897 75.3969 262.191L54.7872 270.793C54.5334 270.901 54.261 270.954 53.9932 270.954ZM55.6185 250.084L55.9911 265.799L70.2369 259.853L55.6185 250.084Z",
    fill: "#FFB0EB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M319.032 227.317C318.606 227.317 318.187 227.18 317.84 226.914L299.766 213.149C299.181 212.703 298.893 211.968 299.016 211.243C299.139 210.517 299.659 209.92 300.359 209.698L324.581 201.959C325.272 201.737 326.031 201.917 326.553 202.423C327.075 202.929 327.275 203.683 327.075 204.382L320.927 225.885C320.748 226.512 320.273 227.009 319.654 227.215C319.451 227.285 319.241 227.317 319.032 227.317ZM305.17 212.306L317.933 222.027L322.273 206.843L305.17 212.306Z",
    fill: "url(#paint9_linear)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M64.4271 52.4764C76.7357 45.2008 81.2367 50.6173 75.2827 65.0355C69.3287 79.4561 65.4563 72.5981 65.0954 65.5581C64.7345 58.5181 61.3535 59.9037 57.2506 63.0364C53.1501 66.1716 52.2257 61.8631 64.4271 52.4764Z",
    fill: "#75C4FD"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M298.42 3.01457C295.29 -1.64844 289.783 21.6806 299.794 22.5204C309.804 23.3601 322.487 13.4813 311.958 14.419C303.051 15.2121 303.417 10.4628 298.42 3.01457Z",
    fill: "#FBC49D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M356.87 41.6157C366.885 43.967 377.103 47.0555 383.546 52.7868C389.989 58.5159 391.172 67.5666 383.523 72.5609C379.906 74.9215 374.229 76.8927 374.649 80.2937C374.928 82.554 378.039 84.1706 381.161 84.952C390.559 87.308 401.019 84.7024 409.804 81.4274C418.017 78.3646 425.918 74.5623 431.145 69.2672C436.373 63.9743 438.541 56.953 434.873 51.0817C430.796 44.5548 420.739 40.8086 411.013 38.2823C380.845 30.4492 324.546 28.9819 315.609 28.9819C306.672 28.9819 301.859 30.3232 303.135 32.1684C304.411 34.0135 315.821 34.9372 318.201 35.1775C331.343 36.5071 344.306 38.6648 356.87 41.6157Z",
    fill: "url(#paint10_linear)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M87.703 58.5833C60.2404 65.5906 33.5417 77.9444 13.5024 98.0147C8.93388 102.589 4.6727 107.644 2.16255 113.606C-0.347587 119.569 -0.929716 126.588 1.79698 132.457C5.45042 140.32 14.0473 144.545 22.3182 147.103C25.5618 148.107 28.9778 148.956 32.3215 148.375C35.6653 147.794 38.9182 145.431 39.5376 142.091C40.5877 136.436 34.4358 132.496 30.5123 128.297C21.5544 118.717 23.5057 102.594 31.2923 92.0361C39.0789 81.4784 51.1825 75.1569 62.8554 69.1946C69.154 65.9778 75.9183 62.6678 82.9435 63.4609C87.1395 63.9344 91.049 65.8495 95.2148 66.5447C104.804 68.1449 114.083 63.195 123.136 59.6563C137.54 54.0252 153.239 51.7439 168.649 53.0409C174.585 53.54 181.449 54.1722 186.644 52.0285C189.229 50.9624 188.619 47.1182 185.838 46.8429C172.191 45.4853 157.547 48.5435 144.186 49.7308C125.19 51.4126 106.205 53.862 87.703 58.5833Z",
    fill: "url(#paint11_linear)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M216.174 48.4666C215.953 48.0887 215.576 47.8298 215.154 47.7155C211.939 46.8501 208.59 46.4862 205.265 46.6331C203.917 46.6914 202.566 46.6588 201.218 46.5631C199.076 46.4115 196.917 46.4838 194.791 46.7847C193.79 46.927 192.726 47.1486 192.228 48.2637C191.757 49.3204 192.06 50.5637 192.889 51.3708C194.512 52.95 196.813 52.7867 198.915 52.5791C203.689 52.1102 208.465 51.639 213.238 51.1702C214.831 51.0139 217.003 49.8779 216.174 48.4666Z",
    fill: "url(#paint12_linear)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M220.286 121.164C235.037 125.253 250.108 132.3 264.985 128.692C267.19 128.158 269.441 127.325 270.929 125.608C272.417 123.891 272.85 121.087 271.351 119.38C270.035 117.882 267.823 117.7 265.96 116.991C264.1 116.282 262.311 114.138 263.394 112.463C281.831 109.522 301.102 112.036 318.17 119.613C319.158 120.051 320.21 120.574 320.687 121.544C321.512 123.219 320.042 125.284 318.256 125.816C316.47 126.347 314.561 125.834 312.752 125.389C305.056 123.495 297.055 122.844 289.155 123.469C288.079 123.553 286.922 123.697 286.13 124.432C284.67 125.783 285.382 128.409 286.987 129.583C288.591 130.756 290.698 130.898 292.68 131.064C309.094 132.436 325.116 138.232 338.617 147.684C340.198 148.792 341.937 150.463 341.404 152.319C340.638 154.99 336.701 154.358 334.183 153.185C318.256 145.758 301.656 139.779 284.656 135.344C281.85 134.612 278.988 133.919 276.092 134.043C270.96 134.262 266.302 137.003 261.317 138.249C252.189 140.53 242.575 137.672 233.952 133.908C225.33 130.14 216.98 125.393 207.74 123.625C199.416 122.032 190.847 122.949 182.369 122.916C181.47 122.911 180.515 122.881 179.768 122.384C172.268 117.395 190.372 116.816 192.156 116.947C201.723 117.654 210.993 118.587 220.286 121.164Z",
    fill: "url(#paint13_linear)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M154.178 98.2761C152.412 98.3811 150.582 98.5351 149.097 99.2419C147.611 99.9487 146.582 101.367 147.178 102.636C148.002 104.392 151.046 104.745 153.502 104.791C163.047 104.976 172.591 105.16 182.136 105.344C185.671 105.412 192.358 104.756 190.251 100.851C188.97 98.4791 185.168 97.9636 182.346 98.0382C172.999 98.2901 163.55 97.7116 154.178 98.2761Z",
    fill: "url(#paint14_linear)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M204.35 127.756C199.029 127.35 193.688 127.336 188.353 127.343C181.375 127.353 174.107 127.465 167.878 130.616C167.164 130.978 166.404 131.454 166.188 132.226C165.922 133.17 166.633 134.169 167.527 134.572C168.421 134.976 169.441 134.936 170.421 134.897C179.735 134.519 189.42 134.841 197.793 138.944",
    fill: "url(#paint15_linear)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M403.205 193.162C403.145 193.162 403.087 193.162 403.026 193.162C395.731 193.064 389.875 187.039 389.973 179.731C390.07 172.422 396.078 166.551 403.38 166.654C410.675 166.752 416.532 172.777 416.434 180.085C416.336 187.331 410.419 193.162 403.205 193.162ZM403.201 170.09C397.859 170.09 393.477 174.407 393.405 179.775C393.333 185.187 397.668 189.649 403.07 189.722C408.473 189.805 412.927 185.45 412.999 180.039C413.071 174.627 408.736 170.164 403.334 170.092C403.289 170.09 403.245 170.09 403.201 170.09Z",
    fill: "#86E29B"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M273.938 169.488C270.096 164.533 268.158 158.426 268.408 152.252C268.44 151.473 268.447 150.689 268.428 149.9C267.974 129.077 250.166 112.244 228.499 112.144C206.243 112.041 188.167 129.352 188.167 150.721C188.167 150.794 188.167 150.866 188.167 150.938C188.206 157.26 185.99 163.416 181.838 168.317C176.054 175.142 172.438 184.881 172.438 195.688C172.438 201.69 175.027 237.238 137.65 254.628L242.98 240.093L309.697 254.628C275.528 234.849 282.393 201.854 282.393 195.688C282.393 185.483 279.168 176.234 273.938 169.488Z",
    fill: "#2E3446"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M266.026 233.221H189.741V267.999H265.092L266.026 233.221Z",
    fill: "#FFD33D"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M139.219 328.399C127.847 328.399 117.864 326.012 110.168 321.424C99.6948 315.182 94.4929 305.396 95.9016 294.577C98.9543 271.118 131.733 247.539 188.211 228.178L218.258 217.366L228.515 238.95L198.149 249.876C172.542 258.647 151.942 268.447 138.574 278.218C125.08 288.079 122.889 294.78 122.575 297.204C122.335 299.042 122.714 300.586 125.336 302.149C135.24 308.051 155.495 304.265 170.389 297.477L182.844 318.168C169.59 324.209 155.849 327.713 143.108 328.303C141.794 328.368 140.497 328.399 139.219 328.399Z",
    fill: "#FFD33D"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M315.613 328.399C326.986 328.399 336.968 326.012 344.664 321.424C355.138 315.182 360.34 305.396 358.931 294.577C355.878 271.118 323.1 247.539 266.621 228.178L236.574 217.366L226.317 238.95L256.683 249.876C282.29 258.647 302.89 268.447 316.258 278.218C329.752 288.079 331.943 294.78 332.258 297.204C332.498 299.042 332.118 300.586 329.496 302.149C319.593 308.051 299.337 304.265 284.444 297.477L271.989 318.168C285.243 324.209 298.983 327.713 311.725 328.303C313.038 328.368 314.335 328.399 315.613 328.399Z",
    fill: "#FFD33D"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M203.358 214.247H253.249L248.098 228.957H209.938L203.358 214.247Z",
    fill: "#FFD33D"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M217.862 221.602V254.628H228.303H228.515H239.071V221.602H217.862Z",
    fill: "#F66A0A"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M255.889 155.214V186.53C255.889 201.161 243.548 213.023 228.329 213.023C213.11 213.023 200.769 201.161 200.769 186.53V155.214C200.769 147.897 203.854 141.274 208.842 136.481C212.789 132.688 217.925 130.04 223.667 129.1C225.183 128.85 226.741 128.722 228.329 128.722C229.917 128.722 231.475 128.85 232.991 129.1H232.993C245.993 131.232 255.889 142.109 255.889 155.214Z",
    fill: "#EDA5AC"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M217.862 180.892H239.071V226.741C239.071 232.608 234.323 237.364 228.466 237.364C222.61 237.364 217.862 232.608 217.862 226.741V180.892Z",
    fill: "#EDA5AC"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M230.618 204.077H226.043C219.928 204.077 214.973 199.11 214.973 192.987V192.467H241.688V192.987C241.688 199.11 236.73 204.077 230.618 204.077Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M264.566 163.812V175.961C263.147 176.267 261.683 176.423 260.193 176.423C246.701 176.423 235.764 163.511 235.764 147.584C235.764 141.099 237.576 135.114 240.635 130.297H240.638C254.222 133.033 264.566 146.994 264.566 163.812Z",
    fill: "#2E3446"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M240.342 116.912H216.265V135.608H240.342V116.912Z",
    fill: "#2E3446"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M196.713 169.269C198.953 169.269 200.769 171.088 200.769 173.332V186.53C196.256 186.53 192.596 182.866 192.596 178.343V173.393C192.596 171.114 194.44 169.269 196.713 169.269Z",
    fill: "#EDA5AC"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M259.946 169.269C257.706 169.269 255.889 171.088 255.889 173.332V186.53C260.402 186.53 264.063 182.866 264.063 178.343V173.393C264.063 171.114 262.221 169.269 259.946 169.269Z",
    fill: "#EDA5AC"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M240.342 135.608C235.762 147.584 227.055 160.255 214.97 160.255C202.885 160.255 200.766 173.33 200.766 173.33L193.89 157.799L200.766 130.294L217.86 122.482L244.72 126.256L240.342 135.608Z",
    fill: "#2E3446"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M318.776 250.943C336.922 246.601 354.009 237.88 368.18 225.724C374.933 219.932 381.161 213.172 384.503 204.917C385.183 203.237 385.69 201.177 384.598 199.733C383.453 198.219 381.038 198.266 379.45 199.304C377.862 200.34 376.891 202.073 375.948 203.72C371.102 212.174 365.167 220.289 357.022 225.619C355.294 226.75 352.598 227.567 351.484 225.824C350.562 224.383 351.671 222.535 352.765 221.222C357.534 215.495 362.88 210.223 367.095 204.077C371.312 197.93 374.395 190.638 373.857 183.202C373.321 175.763 368.438 168.338 361.213 166.539C358.878 165.959 355.885 165.543 355.215 163.229C354.635 161.228 356.442 159.252 358.396 158.538C364.391 156.348 370.425 161.587 374.192 166.749C377.957 171.912 382.058 178.061 388.417 178.627C390.056 178.774 391.712 178.513 393.351 178.672C399.801 179.302 403.888 186.097 405.101 192.474C407.029 202.6 403.681 214.236 395.009 219.785C390.466 222.692 384.994 223.699 380.086 225.932C370.136 230.455 363.216 239.585 355.159 246.979C353.534 248.472 351.822 249.918 349.82 250.842C344.802 253.156 338.959 251.824 333.438 252.069C326.881 252.358 320.802 254.931 314.829 257.432C310.938 259.063 300.918 265.03 296.837 262.132C288.025 255.874 316.266 251.542 318.776 250.943Z",
    fill: "url(#paint16_linear)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M338.526 52.6119L370.35 57.184V25.301L338.526 20.729V52.6119Z",
    fill: "#43AEFC"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M391.551 44.9633L370.35 57.1841V25.3012L391.551 13.0803V44.9633Z",
    fill: "#037DD6"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M359.725 8.50806L338.526 20.7289L370.35 25.301L391.551 13.0801L359.725 8.50806Z",
    fill: "#75C4FD"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 329,
    y: 0,
    width: 72,
    height: 34
  }, /*#__PURE__*/React.createElement("rect", {
    x: 329.921,
    width: 70.0884,
    height: 33.8237,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 330,
    y: 0,
    width: 71,
    height: 34
  }, /*#__PURE__*/React.createElement("rect", {
    x: 330.154,
    width: 69.8555,
    height: 33.8237,
    fill: "url(#pattern1)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M162.038 69.7942L129.521 74.4665V41.8884L162.038 37.2161V69.7942Z",
    fill: "#43AEFC"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M107.858 61.9797L129.521 74.4665V41.8884L107.858 29.4016V61.9797Z",
    fill: "#037DD6"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M140.376 24.7292L162.038 37.216L129.521 41.8884L107.858 29.4016L140.376 24.7292Z",
    fill: "#75C4FD"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "mask2",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 99,
    y: 16,
    width: 72,
    height: 35
  }, /*#__PURE__*/React.createElement("rect", {
    x: 99.3979,
    y: 16.3286,
    width: 71.2526,
    height: 34.057,
    fill: "url(#pattern2)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2)"
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "mask3",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 99,
    y: 16,
    width: 72,
    height: 35
  }, /*#__PURE__*/React.createElement("rect", {
    x: 99.3979,
    y: 16.3286,
    width: 71.0198,
    height: 34.057,
    fill: "url(#pattern3)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M145.781 44.6879C141.489 45.2897 138.008 49.2623 138.008 53.5637C138.008 57.8652 145.781 66.9952 145.781 66.9952C145.781 66.9952 153.553 55.6841 153.553 51.385C153.553 47.0859 150.072 44.0861 145.781 44.6879ZM145.781 54.9517C143.95 55.2083 142.469 53.93 142.469 52.0988C142.469 50.2677 143.953 48.5718 145.781 48.3152C147.611 48.0586 149.092 49.3369 149.092 51.1681C149.092 53.0016 147.609 54.6951 145.781 54.9517Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M302.457 178.271L338.042 183.384V147.738L302.457 142.625V178.271Z",
    fill: "#43AEFC"
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "mask4",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 294,
    y: 134,
    width: 53,
    height: 58
  }, /*#__PURE__*/React.createElement("rect", {
    x: 294.062,
    y: 134.128,
    width: 52.3917,
    height: 57.8502,
    fill: "url(#pattern4)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M361.746 169.719L338.042 183.384V147.738L361.746 134.073V169.719Z",
    fill: "#037DD6"
  }))), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "mask5",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 329,
    y: 125,
    width: 42,
    height: 67
  }, /*#__PURE__*/React.createElement("rect", {
    x: 329.456,
    y: 125.498,
    width: 40.7491,
    height: 66.4811,
    fill: "url(#pattern5)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.162 128.96L302.457 142.623L338.042 147.738L361.746 134.073L326.162 128.96Z",
    fill: "#75C4FD"
  }))), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "mask6",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 294,
    y: 120,
    width: 77,
    height: 37
  }, /*#__PURE__*/React.createElement("rect", {
    x: 294.062,
    y: 120.366,
    width: 76.1425,
    height: 35.9231,
    fill: "url(#pattern6)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6)"
  })), _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", {
    id: "mask7",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 294,
    y: 120,
    width: 77,
    height: 37
  }, /*#__PURE__*/React.createElement("rect", {
    x: 294.062,
    y: 120.599,
    width: 76.1425,
    height: 35.6898,
    fill: "url(#pattern7)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M328.612 172.081C332.985 167.986 332.738 160.602 328.059 155.588C323.381 150.575 316.044 149.831 311.671 153.926C307.297 158.022 307.545 165.406 312.223 170.419C316.901 175.432 324.239 176.176 328.612 172.081Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M320.145 156.282C320.145 159.996 317.141 162.599 313.434 162.098C317.141 162.599 320.145 166.014 320.145 169.728C320.145 166.014 323.149 163.411 326.856 163.913C323.151 163.409 320.145 159.994 320.145 156.282Z",
    fill: "#43AEFC"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M359.676 34.5475C361.533 34.5475 363.038 33.0395 363.038 31.1792C363.038 29.3189 361.533 27.8108 359.676 27.8108C357.819 27.8108 356.314 29.3189 356.314 31.1792C356.314 33.0395 357.819 34.5475 359.676 34.5475Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M348.031 41.2516C349.888 41.2516 351.394 39.7436 351.394 37.8833C351.394 36.023 349.888 34.5149 348.031 34.5149C346.174 34.5149 344.669 36.023 344.669 37.8833C344.669 39.7436 346.174 41.2516 348.031 41.2516Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M358.307 50.1366C360.164 50.1366 361.669 48.6286 361.669 46.7683C361.669 44.908 360.164 43.3999 358.307 43.3999C356.45 43.3999 354.945 44.908 354.945 46.7683C354.945 48.6286 356.45 50.1366 358.307 50.1366Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M357.483 47.466L346.408 37.7224L359.203 30.3535L360.149 32.005L349.656 38.0467L358.738 46.0361L357.483 47.466Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M189.645 265.312C178.082 265.288 166.742 263.387 155.43 261.148C154.075 260.88 152.664 261.535 152.28 262.939C151.933 264.201 152.706 265.825 154.068 266.095C160.746 267.418 167.45 268.633 174.2 269.44C174.449 269.585 174.74 269.681 175.08 269.706C177.493 269.898 180.217 272.403 178.489 274.862C177.944 275.636 177.13 276.128 176.214 276.415C167.42 275.571 156.371 273.446 146.561 269.361C134.257 265.403 122.647 259.284 112.42 251.367C107.665 247.686 103.118 243.508 100.277 238.204C98.2324 234.387 97.3871 229.099 100.556 226.151C102.077 224.735 104.207 224.198 106.263 223.909C110.14 223.363 114.113 223.524 117.934 224.376C120.742 225.003 123.499 226.004 126.375 226.116C129.251 226.228 132.401 225.232 133.889 222.764C135.791 219.61 134.147 215.283 131.255 213.006C128.363 210.729 124.591 209.988 120.975 209.314C117.44 208.656 113.906 207.998 110.371 207.34C103.865 206.129 99.1428 204.655 92.765 206.433C86.3895 208.21 80.5869 211.574 74.8634 214.903C73.4593 215.719 71.969 216.626 71.2984 218.108C70.6534 219.528 70.9026 221.189 71.3589 222.68C72.6815 226.991 75.5782 230.62 78.5634 233.996C101.329 259.755 144.402 286.775 190.605 283.028V276.459C188.802 276.802 187.149 270.434 189.645 270.439C192.942 270.448 192.947 265.316 189.645 265.312Z",
    fill: "url(#paint17_linear)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M283.331 269.613C281.072 271.055 278.404 271.02 275.812 271.022C272.951 271.024 269.947 270.982 267.253 272.088C265.974 272.613 265.066 273.793 265.464 275.244C265.797 276.457 267.327 277.565 268.615 277.035C271.258 275.951 274.096 276.182 276.893 276.147C280.025 276.109 283.215 275.764 285.916 274.04C288.689 272.275 286.123 267.831 283.331 269.613Z",
    fill: "#75C3FC"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M292.512 267.439C289.215 267.439 289.211 272.571 292.512 272.571C295.81 272.571 295.814 267.439 292.512 267.439Z",
    fill: "#75C3FC"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M189.042 298.3H266.061C269.183 298.3 271.716 295.765 271.716 292.634V260.292C271.716 257.164 269.185 254.626 266.061 254.626H189.042C185.92 254.626 183.386 257.161 183.386 260.292V292.634C183.389 295.762 185.92 298.3 189.042 298.3Z",
    fill: "#2E3446"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M184.935 292.487C184.374 296.103 180.04 304.601 176.238 307.2L173.39 302.467L171.655 299.583C173.064 295.781 173.728 291.491 174.068 289.616C174.533 287.034 175.574 282.158 180.953 278.573C186.334 274.988 184.162 279.434 183.54 282.303C183.354 283.159 183.459 284.052 183.685 284.992C184.201 287.204 185.373 289.667 184.935 292.487Z",
    fill: "#EDA5AC"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M215.737 287.64C214.805 291.944 203.761 306.451 200.808 308.028C197.858 309.607 195.211 311.541 186.02 313.859C184.146 314.659 182.492 315.063 181.035 315.175L176.236 307.202L173.388 302.469L179.966 288.328C181.084 287.358 182.339 286.222 183.682 284.995C188.672 280.43 194.847 274.598 199.53 271.169C207.971 264.99 206.951 268.445 200.799 276.392C196.906 281.426 194.095 285.174 194.095 285.174L195.339 285.893C195.339 285.893 200.152 282.737 204.499 279.87C208.849 277.001 212.032 275.608 214.982 275.018C217.93 274.423 216.668 283.336 215.737 287.64Z",
    fill: "#EDA5AC"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M283.18 299.586L281.445 302.471L278.597 307.204C274.792 304.606 270.457 296.105 269.898 292.49C269.465 289.672 270.634 287.206 271.153 284.997C271.376 284.055 271.481 283.161 271.297 282.305C270.676 279.438 268.503 274.99 273.882 278.575C279.263 282.161 280.304 287.036 280.77 289.618C281.105 291.491 281.771 295.781 283.18 299.586Z",
    fill: "#EDA5AC"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M281.445 302.469L278.597 307.202L273.798 315.173C272.34 315.061 270.687 314.657 268.81 313.857C259.622 311.538 256.972 309.604 254.022 308.025C251.072 306.448 240.028 291.941 239.099 287.638C238.165 283.334 236.903 274.421 239.853 275.011C242.803 275.601 245.989 276.994 250.334 279.863C254.683 282.73 259.494 285.886 259.494 285.886L260.737 285.167C260.737 285.167 257.929 281.421 254.034 276.385C247.884 268.437 246.864 264.983 255.305 271.162C259.988 274.591 266.163 280.425 271.153 284.99C272.494 286.215 273.749 287.351 274.869 288.321L281.445 302.469Z",
    fill: "#EDA5AC"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M266.026 263.308C267.135 263.308 268.035 262.407 268.035 261.295C268.035 260.183 267.135 259.282 266.026 259.282C264.916 259.282 264.016 260.183 264.016 261.295C264.016 262.407 264.916 263.308 266.026 263.308Z",
    fill: "#666666"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M266.026 266.338C266.516 266.338 266.913 265.94 266.913 265.449C266.913 264.958 266.516 264.561 266.026 264.561C265.536 264.561 265.138 264.958 265.138 265.449C265.138 265.94 265.536 266.338 266.026 266.338Z",
    fill: "#666666"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M122.214 219.362L83.6028 224.91V186.229L122.214 180.682V219.362Z",
    fill: "#43AEFC"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8818 210.083L83.6026 224.91V186.229L57.8818 171.403V210.083Z",
    fill: "#037DD6"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4933 165.854L122.214 180.68L83.6026 186.229L57.8818 171.403L96.4933 165.854Z",
    fill: "#75C4FD"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M111.21 203.12C111.254 202.754 111.282 202.376 111.282 201.987C111.282 201.597 111.254 201.226 111.196 200.874L113.627 198.625C113.843 198.422 113.899 198.096 113.771 197.87L111.47 194.207C111.326 193.969 111.026 193.925 110.765 194.049L107.903 195.612C107.3 195.236 106.667 194.954 105.961 194.765L105.53 191.772C105.486 191.49 105.242 191.324 104.955 191.364L100.352 192.022C100.063 192.064 99.8347 192.297 99.7905 192.591L99.3597 195.707C98.6542 196.097 98.0069 196.577 97.4177 197.109L94.556 196.365C94.2975 196.302 93.9948 196.444 93.8504 196.724L91.5499 201.044C91.4055 201.324 91.4637 201.618 91.6942 201.758L94.1252 203.312C94.067 203.68 94.0251 204.074 94.0251 204.45C94.0251 204.826 94.053 205.21 94.1112 205.563L91.6803 207.811C91.4637 208.014 91.4078 208.341 91.5359 208.567L93.8365 212.229C93.9808 212.467 94.2812 212.512 94.542 212.388L97.4038 210.825C98.0069 211.201 98.6402 211.483 99.3458 211.672L99.7765 214.665C99.8347 214.945 100.065 215.113 100.352 215.073L104.955 214.415C105.244 214.373 105.488 214.138 105.516 213.846L105.947 210.73C106.653 210.34 107.3 209.859 107.889 209.328L110.751 210.072C111.009 210.135 111.312 209.992 111.456 209.712L113.757 205.392C113.901 205.112 113.843 204.819 113.613 204.679L111.21 203.12ZM102.652 207.543C100.279 207.884 98.3375 206.216 98.3375 203.836C98.3375 201.46 100.279 199.236 102.652 198.896C105.025 198.555 106.967 200.223 106.967 202.603C106.967 204.98 105.025 207.203 102.652 207.543Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image2"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern3",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image3"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern4",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image4"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern5",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image5"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern6",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image6"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern7",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 231.786,
    y1: 83.8433,
    x2: 365.038,
    y2: 83.8433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAFEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 111.271,
    y1: 143.292,
    x2: 111.271,
    y2: 54.0616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAFEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 78.6232,
    y1: 72.7308,
    x2: 89.1675,
    y2: 163.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75C3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0929,
    stopColor: "#81C2F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0B8BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 275.424,
    y1: 5.19083,
    x2: 280.828,
    y2: 5.19083,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75C3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75C3FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 305.036,
    y1: 97.8378,
    x2: 310.439,
    y2: 97.8378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75C3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75C3FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 30.4776,
    y1: 176.423,
    x2: 35.8813,
    y2: 176.423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75C3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75C3FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 313.465,
    y1: 122.539,
    x2: 318.869,
    y2: 122.539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75C3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75C3FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 430.24,
    y1: 198.441,
    x2: 439.006,
    y2: 198.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75C3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75C3FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 242.504,
    y1: 57.3724,
    x2: 284.52,
    y2: 55.8826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75C3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0929,
    stopColor: "#81C2F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0B8BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 298.989,
    y1: 214.593,
    x2: 327.151,
    y2: 214.593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAFEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 304.208,
    y1: 57.4209,
    x2: 389.426,
    y2: 57.4209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75C3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0929,
    stopColor: "#81C2F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0B8BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: -1.10816,
    y1: 102.882,
    x2: 190.514,
    y2: 93.0953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75C3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0929,
    stopColor: "#81C2F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0B8BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 192.032,
    y1: 49.0076,
    x2: 216.278,
    y2: 50.5524,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75C3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0929,
    stopColor: "#81C2F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0B8BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 177.956,
    y1: 132.731,
    x2: 341.5,
    y2: 132.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75C3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0929,
    stopColor: "#81C2F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0B8BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear",
    x1: 168.83,
    y1: 143.292,
    x2: 168.83,
    y2: 54.0617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAFEA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear",
    x1: 161.151,
    y1: 133.686,
    x2: 228.149,
    y2: 132.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75C3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0929,
    stopColor: "#81C2F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0B8BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear",
    x1: 295.14,
    y1: 210.469,
    x2: 405.629,
    y2: 210.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75C3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0929,
    stopColor: "#81C2F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0B8BD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear",
    x1: 70.91,
    y1: 244.496,
    x2: 192.12,
    y2: 244.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#75C3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0929,
    stopColor: "#81C2F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0B8BD"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAS0AAACRCAYAAACWnO5UAAAACXBIWXMAAAsSAAALEgHS3X78AAAA"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASwAAACRCAYAAAB5XoVqAAAACXBIWXMAAAsSAAALEgHS3X78AAAA"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image2",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATIAAACSCAYAAADGrUafAAAACXBIWXMAAAsSAAALEgHS3X78AAAA"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image3",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATEAAACSCAYAAAAtmv2cAAAACXBIWXMAAAsSAAALEgHS3X78AAAA"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image4",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAAD4CAYAAAAaaoEpAAAACXBIWXMAAAsSAAALEgHS3X78AAAA"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image5",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAK8AAAEdCAYAAAB65ze/AAAACXBIWXMAAAsSAAALEgHS3X78AAAA"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image6",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAUcAAACaCAYAAAA6noouAAAACXBIWXMAAAsSAAALEgHS3X78AAAA"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image7",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAUcAAACZCAYAAAC8CviAAAAACXBIWXMAAAsSAAALEgHS3X78AAAA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExploreIllo);
export default __webpack_public_path__ + "static/media/Explore-illo.bdac242372032b8344db8e9b3e14acef.svg";
export { ForwardRef as ReactComponent };